import {makeStyles} from '@mui/styles'
import {FC, useContext} from 'react'

import {ApiUrlsContext} from '../../../contexts/ApiUrlsContext'


const TemplateHeaderMedia: FC<TemplateHeaderMediaProps> = ({
  templateHeaderMediaKey, templateHeaderMediaMimeType,
}) => {
  const styles = useStyles()
  const mediaUrl = useContext(ApiUrlsContext).getFilesApiUrl(templateHeaderMediaKey)
  return (
    <>
      {templateHeaderMediaMimeType.startsWith('image/') && (
        <img
          alt="Template image"
          className={styles.root}
          loading="lazy"
          src={mediaUrl}
        />
      )}
      {templateHeaderMediaMimeType.startsWith('video/') && (
        <video
          className={styles.root}
          controls
          muted
          src={mediaUrl}
        />
      )}
      {templateHeaderMediaMimeType.startsWith('application/') && (
        <iframe loading="lazy" className={styles.root} src={mediaUrl} />
      )}
    </>
  )
}

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '5px',
    height: '185px',
    objectFit: 'cover',
    width: '100%',
  },
}))

interface TemplateHeaderMediaProps {
  templateHeaderMediaKey: string
  templateHeaderMediaMimeType: string
}

export default TemplateHeaderMedia
